import { render, staticRenderFns } from "./assetstatistic.vue?vue&type=template&id=804cd280&"
import script from "./assetstatistic.vue?vue&type=script&lang=js&"
export * from "./assetstatistic.vue?vue&type=script&lang=js&"
import style0 from "./assetstatistic.vue?vue&type=style&index=0&id=804cd280&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports